import { useMutation } from '@tanstack/react-query'

import { updateComment } from '@src/api'
import { DefaultApiUpdateCommentRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useUpdateComment = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiUpdateCommentRequest) =>
      updateComment(axiosInstance, params),
  })
}
